import {styled} from '@esgi/ui/theme';
import {ListRow} from '../components.styled';

export const ListHeaderRow = styled(ListRow);
